import ApiResponse from "../models/ApiResponse";
import axios from "./axios-instance";
import Contact from "../models/Contact";

export const getAllContactsForClient = async (clientId: number): Promise<ApiResponse<Contact[]>> => {
   try {
       const response = await axios.get('/contact/all/' + clientId);
       return {
           data: response.data ? response.data as Contact[] : [],
           status: response.status
       }
   } catch (err: any) {
       console.error('Failed to get contacts for client', err.response?.data || err.message);
       return {
           data: [],
           status: err.status
       }
   }
}

export const addNewContact = async (contact: Contact): Promise<ApiResponse<Contact>> => {
    try {
        const response = await axios.post('/contact/add', contact);
        return {
            data: response.data,
            status: response.status
        }
    } catch (err: any) {
        console.error('Failed to add new contact', err.reponse?.data || err.message);
        return {
            data: null,
            status: err.status
        }
    }
};

export const updateContact = async (contact: Contact): Promise<ApiResponse<Contact>> => {
    try {
        const response = await axios.post('/contact/update', contact);
        return {
            data: response.data,
            status: response.status
        }
    } catch (err: any) {
        console.error('Failed to update contact', err.reponse?.data || err.message);
        return {
            data: null,
            status: err.status
        }
    }
}

export const deleteContact = async (id: number): Promise<{status: number}> => {
    try {
        const response = await axios.delete('/contact/delete/' + id);
        return {
            status: response.status
        }
    } catch (err: any) {
        console.error('Failed to delete contact', err.reponse?.data || err.message);
        return {
            status: err.status
        }
    }
};
